import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

interface GiveToGuestResponse {
  success: boolean;
  amount: number;
  error?: {
    message: string;
  };
}

export async function giveToGuest(
  loginKey: string,
  sourceAccountId: string,
  destinationCid: string,
  amount: number,
) {
  return post<GiveToGuestResponse>(API_ENDPOINTS.GIVE_TO_GUEST, {
    login_key: loginKey,
    source_account_id: sourceAccountId,
    destination_cid: destinationCid,
    amount,
  });
}

/**
 * Extracts the CID from a scanned QR code.
 * QR codes may be formatted as a URL (https://coreqr.com/{code}/{cid}) or as a raw CID string.
 */
export function extractCidFromQrCode(qrCode: string): string | null {
  if (!qrCode) return null;

  try {
    const url = new URL(qrCode);
    const parts = url.pathname.split('/').filter(Boolean);
    if (parts.length >= 2) {
      return parts[parts.length - 1];
    }
  } catch {
    // Not a URL — treat as raw CID if non-empty
    const trimmed = qrCode.trim();
    if (trimmed.length > 0) {
      return trimmed;
    }
  }
  return null;
}

export default {
  giveToGuest,
  extractCidFromQrCode,
};
